// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { capacitorStorage } from '@/lib/capacitor-storage';
import { Capacitor } from '@capacitor/core';

const SUPABASE_URL = "https://ewdidxzgywdsvygvdcji.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV3ZGlkeHpneXdkc3Z5Z3ZkY2ppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMyNzMxNjIsImV4cCI6MjA2ODg0OTE2Mn0.JFGfKXjQo3y8MciL9N8EQzn2yLAEaVPEAalwGfwwHI8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

const isNative = Capacitor.isNativePlatform();

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: isNative
    ? {
        storage: capacitorStorage,
        persistSession: true,
        autoRefreshToken: true,
      }
    : {
        // On web, let Supabase use its default localStorage-based persistence.
        persistSession: true,
        autoRefreshToken: true,
      },
});
